// src/telas/cadastro-tecnico/index.tsx

import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";
import { RxDotFilled } from "react-icons/rx";
import { DadosBasicos } from "./dados-basicos";
import { Endereco } from "./endereco";
import { Contato } from "./contato";
import { CadastroType, TecnicoDefault } from "../../context/parceiro-cadastro";
import { AuthFetchJson, url } from "../../api";
import Swal from "sweetalert2";
import { ContextRegister } from "../../context";
import { Menu } from "../menu";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

type documentosType = {
  file: any;
  name: any;
};

export const FormularioContext = createContext<{
  formulario: CadastroType;
  setFormulario: Dispatch<SetStateAction<CadastroType>>;
} | null>(null);

export const ArquivosContext = createContext<{
  documentos: documentosType[];
  setDocumentos: Dispatch<SetStateAction<documentosType[]>>;
} | null>(null);

const TABS = [
  { key: "dadosbasicos", label: "Dados Básicos", step: 1 },
  { key: "endereco", label: "Endereço", step: 2 },
  { key: "contato", label: "Contato", step: 3 },
] as const;

type TabKey = (typeof TABS)[number]["key"];

export function CadastrarTecnico() {
  const {
    state: { usuario },
  } = useContext(ContextRegister);

  const [documentos, setDocumentos] = useState<documentosType[]>([]);
  const navigate = useNavigate();
  const [tab, setTab] = useState<TabKey>("dadosbasicos");
  const [formulario, setFormulario] = useState(TecnicoDefault);

  const currentStep = TABS.find((t) => t.key === tab)?.step ?? 1;

  /* ── Validações por etapa ───────────────────────────────── */
  const isDadosBasicosValido = () => {
    const { A2_CGC, A2_NOME, A2_ZSENHA } = formulario;
    const senhaOk = (A2_ZSENHA ?? "").length >= 6;
    if (formulario.A2_TIPO === "J") {
      return !!(A2_CGC && A2_NOME && formulario.A2_NREDUZ && senhaOk);
    }
    return !!(A2_CGC && A2_NOME && senhaOk);
  };

  const isEnderecoValido = () => {
    const { A2_CEP, A2_END, A2_BAIRRO, A2_EST, A2_MUN, A2_ZNUMERO } =
      formulario;
    return !!(A2_CEP && A2_END && A2_BAIRRO && A2_EST && A2_MUN && A2_ZNUMERO);
  };

  const isContatoValido = () => {
    const { A2_TEL, A2_EMAIL } = formulario;
    return !!(A2_TEL && A2_EMAIL);
  };

  const isCurrentStepValido = () => {
    if (tab === "dadosbasicos") return isDadosBasicosValido();
    if (tab === "endereco") return isEnderecoValido();
    if (tab === "contato") return isContatoValido();
    return false;
  };

  /* ── Renderização da aba ────────────────────────────────── */
  function selectedTab() {
    switch (tab) {
      case "dadosbasicos":
        return <DadosBasicos />;
      case "endereco":
        return <Endereco />;
      case "contato":
        return <Contato />;
      default:
        return <DadosBasicos />;
    }
  }

  /* ── Navegação e submit ─────────────────────────────────── */
  function handleBack() {
    if (tab === "endereco") setTab("dadosbasicos");
    if (tab === "contato") setTab("endereco");
  }

  async function handleNext() {
    if (tab === "dadosbasicos") {
      setTab("endereco");
      return;
    }
    if (tab === "endereco") {
      setTab("contato");
      return;
    }

    // tab === "contato" → submete
    let aux = { ...formulario };
    aux.A2_DTNASC = aux.A2_DTNASC?.replaceAll("-", "");
    aux.A2_CEP = aux.A2_CEP.replace(/\D/g, "");
    aux.A2_CGC = aux.A2_CGC.replace(/\D/g, "");
    if (aux.A2_NREDUZ === "") {
      aux.A2_NREDUZ = aux.A2_NOME.substring(0, 20);
    }
    if (aux.A2_ZOBSERV) {
      aux.A2_ZOBSERV = aux.A2_ZOBSERV.substring(0, 40);
    }

    Swal.fire({
      title: "Cadastro!",
      html: "Aguarde, salvando seus dados no sistema.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const cgcLimpo = (aux.A2_CGC ?? "").replace(/[^\d]/g, "").trim();

      console.log(
        "Token no localStorage:",
        localStorage.getItem("IPEST-TOKEN"),
      );
      console.log(
        "Primeiros 8 chars do token:",
        localStorage.getItem("IPEST-TOKEN")?.substring(0, 8),
      );
      console.log(
        "Chave esperada pelo Protheus:",
        usuario.A2_COD + usuario.A2_LOJA,
      );

      const buscaRetorno: any = await AuthFetchJson(url + "COLETAFORNECEDOR", {
        method: "POST",
        body: JSON.stringify({
          A2_CGC: cgcLimpo,
          A2_COD: usuario.A2_COD.trim(), // Adicione .trim()
          A2_LOJA: usuario.A2_LOJA.trim(), // Adicione .trim()
          A2_ZTIPFOR: "T",
        }),
      });
      console.log(
        JSON.stringify(usuario.A2_COD), // vai mostrar se tem espaços
        JSON.stringify(usuario.A2_LOJA),
      );

      let codTecnico = "";
      let lojaTecnico = "";

      if (buscaRetorno.sucesso === "T" && buscaRetorno.dados.length > 0) {
        codTecnico = buscaRetorno.dados[0].A2_COD;
        lojaTecnico = buscaRetorno.dados[0].A2_LOJA;
      } else {
        const insertRetorno: any = await AuthFetchJson(url + "INSERETECNICO", {
          method: "POST",
          body: JSON.stringify({
            dados: aux,
            parceiro: usuario.A2_COD,
            loja: usuario.A2_LOJA,
          }),
        });

        // 🔧 Verificação especial para rotas de técnico
        if (insertRetorno.sucesso === "E") {
          // Se for erro de autenticação, mas os dados foram salvos, continua
          console.log(
            "Aviso de autenticação, mas continuando...",
            insertRetorno.mensagem,
          );
          // Continua mesmo com erro
        } else if (insertRetorno.sucesso !== "T") {
          throw new Error(insertRetorno.mensagem);
        }

        codTecnico = insertRetorno.dados[0].A2_COD;
        lojaTecnico = insertRetorno.dados[0].A2_LOJA;

        if (documentos.length > 0) {
          await Promise.all(
            documentos.map((doc) =>
              AuthFetchJson(url + "ENVIADOCUMENTOTEC", {
                method: "POST",
                body: JSON.stringify({
                  PARCEIRO: codTecnico,
                  LOJA: lojaTecnico,
                  ARQBASE64: `${doc.file}`.replace(/^.*,/, ""),
                  NOMEARQ: `${doc.name}`,
                }),
              }),
            ),
          );
        }
      }

      const buscaVinculo: any = await AuthFetchJson(url + "COLETAFORNECEDOR", {
        method: "POST",
        body: JSON.stringify({ TECNICO: codTecnico, LOJA: lojaTecnico }),
      });

      const jaVinculado =
        buscaVinculo.sucesso === "T" &&
        buscaVinculo.dados.some(
          (t: any) => t.A2_COD === codTecnico && t.A2_LOJA === lojaTecnico,
        );

      if (jaVinculado) {
        throw new Error("Este técnico já está vinculado a este parceiro.");
      }

      const vinculoRetorno: any = await AuthFetchJson(url + "ACEITATECNICO", {
        method: "POST",
        body: JSON.stringify({
          PARCEIRO: usuario.A2_COD,
          LOJA: usuario.A2_LOJA,
          TECNICO: codTecnico,
          LOJTEC: lojaTecnico,
        }),
      });

      if (vinculoRetorno.sucesso !== "T") {
        throw new Error(vinculoRetorno.mensagem);
      }

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Cadastro realizado com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      });

      navigate("/tecnicos");
    } catch (error: any) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Erro ao cadastrar técnico: " + error.message,
        showConfirmButton: false,
        timer: 2500,
      });
    } finally {
      if (Swal.isLoading()) Swal.close();
    }
  }

  const isDisabled = !isCurrentStepValido();

  /* ── Render ─────────────────────────────────────────────── */
  return (
    <div className={styles.container}>
      <div className={styles.blobTop} aria-hidden="true" />
      <div className={styles.blobBottom} aria-hidden="true" />

      <Menu />

      <div className={styles.content}>
        {/* Progress stepper */}
        <div className={styles.stepper}>
          {TABS.map((t, i) => {
            const isPast = currentStep > t.step;

            const stepValido =
              t.key === "dadosbasicos"
                ? isDadosBasicosValido()
                : t.key === "endereco"
                  ? isEnderecoValido()
                  : isContatoValido();

            const showCheck = isPast && stepValido;
            const showError = isPast && !stepValido;

            return (
              <div key={t.key} className={styles.stepperItem}>
                <button
                  className={`
                    ${styles.stepCircle}
                    ${tab === t.key ? styles.stepActive : ""}
                    ${showCheck ? styles.stepDone : ""}
                    ${showError ? styles.stepError : ""}
                  `}
                >
                  {showCheck ? "✓" : showError ? "✗" : t.step}
                </button>
                <span
                  className={`${styles.stepLabel} ${tab === t.key ? styles.stepLabelActive : ""}`}
                >
                  {t.label}
                </span>
                {i < TABS.length - 1 && (
                  <div
                    className={`${styles.stepLine} ${showCheck ? styles.stepLineDone : ""}`}
                  />
                )}
              </div>
            );
          })}
        </div>

        {/* Card */}
        <div className={styles.cardForm}>
          <div className={styles.cardHeader}>
            <h1>Cadastro de Técnico</h1>
            <div className={styles.cardHeaderRow}>
              <h2 className={styles.cardTitle}>
                {TABS.find((t) => t.key === tab)?.label}
              </h2>
              <span className={styles.requiredNote}>
                <RxDotFilled size={16} /> Campos Obrigatórios
              </span>
            </div>
          </div>

          <FormularioContext.Provider value={{ formulario, setFormulario }}>
            <ArquivosContext.Provider value={{ documentos, setDocumentos }}>
              {selectedTab()}
            </ArquivosContext.Provider>
          </FormularioContext.Provider>

          <hr className={styles.divider} />

          <div className={styles.actions}>
            {tab !== "dadosbasicos" && (
              <button className={styles.backSecBtn} onClick={handleBack}>
                <FaArrowLeft size={16} /> Voltar
              </button>
            )}
            <button
              disabled={isDisabled}
              className={`
                ${tab === "contato" ? styles.nextBtnConfirmar : styles.nextBtnProximo}
                ${isDisabled ? styles.nextBtnDisabled : ""}
              `}
              onClick={handleNext}
            >
              {tab === "contato" ? "Confirmar e finalizar" : "Próximo"}{" "}
              <FaArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
